<template>
  <div :class="$style.rootWrap">
    <div
      v-if="instructor"
      :class="[
        $style.root,
        $style.rootL
      ]"
    >
      <div :class="$style.info">
        <div :class="$style.hint">
          Инструктор
        </div>
        <template
          v-if="fullName || phoneFormatted || autoInfo || autoPlate"
        >
          <div
            v-if="fullName"
            :class="$style.name"
          >
            {{ fullName }}
          </div>
          <div
            v-if="autoInfo || autoPlate"
            :class="$style.auto"
          >
            {{ autoInfo }}
          </div>
          <a
            v-if="phoneFormatted"
            :class="$style.phone"
            :href="`tel:${phone}`"
          >
            {{ phoneFormatted }}
          </a>
        </template>
        <div
          v-else
          :class="$style.messageEmptyInfo"
        >
          Нет информации...
        </div>
      </div>
      <div
        v-if="autoPlate"
        :class="$style.autoNum"
      >
        {{ autoPlate }}
      </div>
    </div>
    <div
      :class="[
        $style.root,
        (instructor && $style.rootL),
        (!instructor && $style.rootWI),
      ]"
    >
      <div :class="$style.info">
        <div :class="$style.hint">
          Оплата
        </div>

        <template>
          <div
            :class="$style.name"
          >
            {{ lessonsPayed | formatNumber }} руб
            <span
              :class="$style.nameSm"
            >/{{ lessons.costOfEducation | formatNumber }} руб</span>
          </div>
          <div
            :class="$style.payLeft"
          >
            Осталось {{ lessons.leftToPay | formatNumber }} руб
          </div>
        </template>
      </div>
    </div>
    <div
      :class="[
        $style.root,$style.rootS
      ]"
    >
      <div :class="$style.info">
        <div :class="$style.hint">
          Занятий
        </div>

        <template>
          <div
            :class="$style.name"
          >
            {{  lessons.left }}
            <span
              :class="$style.nameSm"
            >/ {{ lessons.inPackage }}</span>
          </div>
        </template>
      </div>
    </div>
    <div
      :class="[
        $style.root,$style.rootS
      ]"
    >
      <div :class="$style.info">
        <div :class="$style.hint">
          Доп. занятий
        </div>

        <template>
          <div
            :class="$style.name"
          >
            {{ lessons.additional }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LessonsInfo',
  filters: {
    formatNumber(num) {
      return Number(num.toString().replace(/ /g, '')).toLocaleString();
    },
  },
  props: {
    lessons: {
      type: Object,
      default: () => [],
    },
    instructor: {
      type: Object,
      default: () => [],
    },
  },
  computed: {
    lessonsPayed() {
      // eslint-disable-next-line no-unused-expressions,radix
      return Number.parseInt(this.lessons.costOfEducation.replace(/ /g, '')) - Number.parseInt(this.lessons.leftToPay.replace(/ /g, ''));
    },
    isLoading() {
      return !this.instructor;
    },
    fullName() {
      return this.instructor?.fullName;
    },
    stylePhoto() {
      const { photo } = this.instructor;
      return (photo) ? { backgroundImage: `url('${photo}')` } : null;
    },
    phone() {
      return this.instructor?.phone?.value;
    },
    phoneFormatted() {
      return this.instructor?.phone?.formatted;
    },
    autoInfo() {
      const auto = this.instructor?.auto ?? {};
      const brand = auto.brand || '';
      const model = auto.model || '';
      const color = auto.color ? `, ${auto.color}` : '';
      return `${brand} ${model}${color}`;
    },
    autoPlate() {
      return this.instructor?.auto?.plate;
    },
  },

};
</script>

<style lang="scss" module>
.rootWrap{
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
  @media( max-width: 1000px){
    justify-content: space-between;
    gap: 0;
  }
  //@include mediaMax('xs') {  justify-content: space-between;}
}
.root {
  border-top: 1px solid rgba(0, 0, 0, 1);
  position: relative;
  @include mediaMin('sm') {
    display: flex;
    padding-top: 8px;
  }
  @media( max-width: 1000px){
    padding-bottom: 40px;
  }
  //@include mediaMax('xs') { padding-bottom: 40px;}
}
.rootL{
  flex-basis: 31.5%;
  @media( max-width: 1000px){
    flex-basis: 100%;
  }
  //@include mediaMax('xs') { flex-basis: 100%;}
}
.rootWI{
  flex-basis: 55.5%;
  @media( max-width: 1000px){
    flex-basis: 100%;
  }
  //@include mediaMax('xs') { flex-basis: 100%;}
}
.rootS{
  flex-basis: 15.4%;
  @media( max-width: 1000px){
    flex-basis: 45%;
  }
  //@include mediaMax('xs') { flex-basis: 45%;}
}
.hint {
  font-weight: 400;
  letter-spacing: 0em;
  text-align: left;
  @include typography(20px, 24px);
  @media( max-width: 1000px){
    margin-top: 8px;
  }
}

.name {
  @include marginY(0, 4px);
  @include typography(36px, 32px);
  font-weight: 500;
}
.nameSm{
  @include typography(20px, 27px);
  font-weight: 500;
  margin-left: -8px;
}

.payLeft{
  color: rgba(226, 84, 84, 1);
  @include typography(20px, 24px);
}
.name {
  @include marginY(0, 4px);
  @include typography(36px, 32px);
  font-weight: 500;
}

.phone,
.auto {
  font-weight: 400;
  @include typography(20px, 24px);
}

.phone {
  @include phoneLink;
  text-decoration: underline;
  text-decoration-color: #0000003b;
  text-underline-offset: 6px;
  text-decoration-thickness: from-font;
}

.messageEmptyInfo {
  margin-top: 30px;
  @include typography(13px, 15px);
  color: $colorGrayDark;
}
.autoNum{
  position: absolute;
  right: 0;
  top: 7px;
  border: 1px solid rgba(0, 0, 0, 1);
  padding: 3px 8px 2px;
  border-radius: 4px;
  font-weight: 400;
  @include typography(15px, 18px);
}
</style>
